import React, { useState, useEffect, useRef } from 'react'
import axiosJWT from '../JwtToken'
import parse from 'html-react-parser'
import { useParams, Link } from "react-router-dom"
import Nav from './Nav'
import { useAuth } from '../AuthContext'

const View = () => {
    const { kategori, code } = useParams()
    const { isLoggedIn } = useAuth()
    const [msg, setMsg] = useState("")
    const [pesan, setPesan] = useState(false)
    const [list, setList] = useState([])
    const [detail, setDetail] = useState({
        name: '', kecamatan: '', kelurahan: '', address: '',
        categoryPath: '', direction: '', imagePath: ''
    })
    const [procurement, setProcurement] = useState([])
    const didFetch = useRef(false)

    // Helper format teks
    const formatTxt = (str) => str ? str.replaceAll('-', ' ').replaceAll('_', '/') : ""

    useEffect(() => {
        if (didFetch.current) return
        didFetch.current = true

        const initLoad = async () => {
            await Promise.all([getData(code), getPengadaan(), getList()])
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
        }
        initLoad()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [code]) // Reload kalau user klik item di sidebar (list)

    const getData = async (value) => {
        try {
            const category = kategori.replaceAll('-', ' ').replaceAll('_', '/').toLowerCase()
            const response = await axiosJWT.post("/api/kegiatan-usaha/filter", {
                kategori: category,
                code: value,
                jml: 1
            })
            if (response.data && response.data.length > 0) {
                setDetail(response.data[0])
            }
        } catch (err) { console.error(err) }
    }

    const getPengadaan = async () => {
        try {
            const response = await axiosJWT.post("/api/procurement/publish", {
                potensialCode: code,
                jml: 10
            })
            setProcurement(response.data)
        } catch (err) { console.error(err) }
    }

    const getList = async () => {
        try {
            const category = kategori.replaceAll('-', ' ').replaceAll('_', '/').toLowerCase()
            const response = await axiosJWT.post("/api/kegiatan-usaha/filter", {
                kategori: category,
                jml: 5
            })
            setList(response.data)
        } catch (err) { console.error(err) }
    }

    const [showModal, setShowModal] = useState(false)
    const [formData, setFormData] = useState({
        judul: detail.name || '', namaPIC: '', noHP: '', npwp: '', deskripsi: ''
    })
    const [file, setFile] = useState(null)

    useEffect(() => {
        setFormData(prev => ({ ...prev, judul: detail.name }))
    }, [detail])

    const handleKirimPenawaran = async (e) => {
        e.preventDefault()
        const data = new FormData()
        Object.keys(formData).forEach(key => data.append(key, formData[key]))
        data.append("potensialCode", code)
        data.append("file", file)

        try {
            await axiosJWT.post("/api/penawaran-usaha", data)
            setPesan(true)
            setMsg("Penawaran berhasil dikirim!")
            setShowModal(false)
        } catch (err) {
            setPesan(true)
            const errorMsg = (err.response && err.response.data && err.response.data.msg)
                ? err.response.data.msg
                : 'Maaf, proses pengiriman data gagal!'
            setMsg(errorMsg)
            setTimeout(() => {
                setPesan(false)
                setMsg('')
            }, 4000)
        }
    }

    return (<>
        <header className="ms-hero-page-override-home no-mt pb-4">
            <div className="container">
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb breadcrumb-slash">
                        <li className="breadcrumb-item"><Link to={'/'} className="btn btn-raised btn-primary br-2 no-m">BERANDA</Link></li>
                        <li className="breadcrumb-item active text-uppercase">KEGIATAN USAHA</li>
                        <li className="breadcrumb-item active">{formatTxt(kategori).toUpperCase()}</li>
                        <li className="breadcrumb-item active text-uppercase">{detail.name}</li>
                    </ol>
                    <div className="btn-group w-300">
                        <button type="button" className="btn btn-warning btn-raised dropdown-toggle" data-toggle="dropdown">
                            MENU KEGIATAN <i className="zmdi zmdi-chevron-down right only"></i>
                        </button>
                        <Nav />
                    </div>
                </nav>

                <div className="row mt-4">
                    {/* Sidebar: List Lainnya */}
                    <div className="col-md-3">
                        <div className="card card-primary">
                            <div className="card-header"><h3 className='panel-title'>LAINNYA DI {formatTxt(kategori).toUpperCase()}</h3></div>
                            <div className="card-body">
                                <div className="ms-media-list">
                                    {list.map((val, index) => (
                                        <div onClick={() => getData(val.potensialCode)} key={index} className="media mb-2 cursor-pointer">
                                            <div className="media-left media-middle">
                                                <img className='d-flex mr-3 media-object' width="100%" src={val.imagePath !== '-' ? val.imagePath : val.categoryPath} title="Preview File" alt="Preview File" />
                                            </div>
                                            <div className="media-body">
                                                <span className="media-heading color-dark font-bold text-small">{val.name}</span>
                                                <div className="media-footer text-small color-dark">
                                                    <span className="mr-1"><i className="fa fa-map color-dark mr-05 small"></i>
                                                        {val.kelurahan}, {val.kecamatan}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Main Content */}
                    <div className="col-md-6">
                        <h1 className='color-dark font-bold lh-125'>{detail.name}</h1>
                        <img className='mb-2' width="100%" src={(detail.imagePath && detail.imagePath !== '-') ? detail.imagePath : detail.categoryPath} title="Preview File" alt="Preview File" />
                        {detail.description ? parse(detail.description) : ''}
                        <i className="zmdi zmdi-pin mr-1"></i>
                        {detail.address ? parse(detail.address) : ''}, {detail.kelurahan}, {detail.kecamatan}
                        <br />
                        {detail.direction && detail.direction.length > 10 && (
                            <a href={detail.direction} target="_blank" rel="noopener noreferrer" className="btn btn-raised btn-warning br-2">
                                Buka di Google Maps <i className="ml-1 zmdi zmdi-google-maps"></i>
                            </a>
                        )}
                        <br />
                        <div className="mt-4 mb-4 p-3 border border-success rounded text-center">
                            <h5 className="font-bold text-success">Tertarik dengan peluang ini?</h5>
                            <p className="text-small mb-3">Ajukan profil usaha dan penawaran Anda sebagai mitra.</p>
                            {isLoggedIn ? (
                                <button className="btn btn-success btn-raised" onClick={() => setShowModal(true)}>
                                    <i className="fa fa-paper-plane mr-2"></i> Ajukan Penawaran Kemitraan
                                </button>
                            ) : (
                                <Link className="btn btn-success btn-raised" to={"/login"}>
                                    <i className="fa fa-paper-plane mr-2"></i> Ajukan Penawaran Kemitraan
                                </Link>
                            )}
                        </div>
                    </div>

                    {/* Right Sidebar: Procurement */}
                    <div className="col-md-3">
                        <div className="card card-success border-success">
                            <div className="card-header bg-success text-white">
                                <h3 className='panel-title mb-0'>
                                    <i className="fa fa-shopping-cart mr-2"></i> KEBUTUHAN PENGADAAN
                                </h3>
                            </div>
                            <div className="card-body p-3">
                                {procurement.length === 0 ? (
                                    <div className='text-center py-4'>
                                        <i className="fa fa-info-circle fa-2x text-muted mb-2"></i>
                                        <p className='text-muted'>Belum ada kebutuhan saat ini.</p>
                                    </div>
                                ) : (
                                    procurement.map((val, index) => (
                                        <Link key={index} className="media mb-2 d-block border-bottom pb-2 text-decoration-none" to={`/kebutuhan-pengadaan/${val.code}/${val.title.replaceAll(' ', '-').toLowerCase()}`}>
                                            <div className="media-body">
                                                <span className="media-heading color-dark font-bold d-block mb-1" style={{ fontSize: '0.95rem' }}>
                                                    {val.title}
                                                </span>
                                                {/* Truncate text biar gak kepanjangan di card */}
                                                <div className="text-small text-muted" style={{
                                                    display: '-webkit-box',
                                                    WebkitLineClamp: '2',
                                                    WebkitBoxOrient: 'vertical',
                                                    overflow: 'hidden'
                                                }}>
                                                    {val.description ? parse(val.description) : ''}
                                                </div>
                                            </div>
                                        </Link>
                                    ))
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </header>
        {showModal && (
            <div className="modal-open">
                <div style={{ display: showModal ? 'block' : 'none' }} className="modal modal-primary show" tabIndex="-1" role="dialog" aria-hidden="true">
                    <div className="modal-dialog modal-md">
                        <div className="modal-content">
                            <div className="modal-header header-modal-primary p-2 d-flex justify-content-between align-items-center">
                                <h4 className="modal-title font-bold" id="myModalLabel">Ajukan Penawaran Kemitraan</h4>
                                <button type="button" className="close text-white" onClick={() => setShowModal(false)}>&times;</button>
                            </div>
                            <form onSubmit={handleKirimPenawaran}>
                                <div className="modal-body">
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label>Nama PIC *</label>
                                                <input className="form-control" placeholder="Nama PIC" onChange={e => setFormData({ ...formData, namaPIC: e.target.value })} required />
                                            </div>
                                            <div className="col-md-6">
                                                <label>NPWP (Perusahaan/Pribadi) *</label>
                                                <input className="form-control" type="number" placeholder="No. NPWP" onChange={e => setFormData({ ...formData, npwp: e.target.value })} required />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <label>No. WhatsApp *</label>
                                                <input className="form-control" type="number" placeholder="08xxxxxxxxxx" onChange={e => setFormData({ ...formData, noHP: e.target.value })} required />
                                            </div>
                                            <div className="col-md-6">
                                                <label>File Proposal *</label>
                                                <div className="form-group is-empty is-fileinput">
                                                    <input type="file" id="inputFile4" multiple="" onChange={e => setFile(e.target.files[0])} required />
                                                    <div className="input-group">
                                                        <input type="text" readonly="" className="form-control" placeholder="Pilih File..." />
                                                        <span className="input-group-btn input-group-sm">
                                                            <button type="button" className="btn btn-fab btn-fab-mini btn-danger">
                                                                <i className="fa fa-file-pdf-o"></i>
                                                            </button>
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group">
                                        <label>Penjelasan Singkat</label>
                                        <textarea className="form-control" rows="3" placeholder="Jelaskan maksud penawaran Anda..." onChange={e => setFormData({ ...formData, deskripsi: e.target.value })} required></textarea>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button className="btn btn-raised btn-primary br-2 no-m mr-2" type="Submit"><i className="fa fa-save"></i> Kirim Penawaran</button>
                                    <button type="button" onClick={() => setShowModal(false)} className="btn btn-raised btn-danger br-2 no-m">
                                        <i className="fa fa-sign-out"></i> Tutup
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in" onClick={() => setShowModal(false)}></div>
            </div>
        )}
        {pesan && (
            <div className="modal-open">
                <div style={{ display: pesan ? 'block' : 'none' }} className="modal modal-primary show" id="myData" tabIndex="-1" role="dialog" aria-hidden="true" onClick={() => setPesan(false)}>
                    <div className="modal-dialog center" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content modal-sm">
                            <div className="modal-header header-modal-primary p-2">
                                <h4 className="modal-title text-center no-p font-bold" id="myModalLabel">
                                    PESAN
                                </h4>
                            </div>
                            <div className="modal-body text-center p-4">
                                <h4 className="font-bold color-dark">{msg ? msg.toUpperCase() : ''}</h4>
                                <button onClick={() => setPesan(false)} className="btn btn-raised btn-primary btn-sm mt-3">OK</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-backdrop fade in"></div>
            </div>
        )}
    </>)
}

export default View